<button class="buttonIconDs__cont" aria-label="buttonIconDs">
  <div
    class="buttonIconDs__icon-cont buttonIconDs__icon-cont--{{type}}"
    [ngStyle]="{ width: buttonSize, height: buttonSize }"
    (click)="clickEvent.emit()">
    <ng-container *ngIf="!isLoading; else loader">
      <app-ds-icon
        class="buttonIconDs__icon buttonIconDs__icon--{{type}}"
        [icon]="icon"
        [color]="iconColor"
        [size]="iconSize">
      </app-ds-icon>
    </ng-container>
  </div>
  <ng-container *ngIf="label">
    <div class="buttonIconDs__label">
      <app-ds-typography
        [text]="label"
        [fontFamily]="labelFontFamily"
        [size]="labelSize"
        [color]="labelColor">
      </app-ds-typography>
    </div>
  </ng-container>
</button>

<ng-template #loader>
  <div class="buttonIconDs__loader">
    <app-ds-loader-ring
      [size]="iconSize + 'px'"
      [type]="loaderRingType">
    </app-ds-loader-ring>
  </div>
</ng-template>